import * as React from "react";
import { SimpleBarChart } from "../";

export class StackedBarChart extends React.Component<SimpleBarChartProps, any> {
  render() {
    return <SimpleBarChart {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/BarChart/StackedBarChart/index.tsx